import {gql} from '@apollo/client'

export const SetAppPushNotificationTokenMutation = gql`
  mutation SetAppPushNotificationToken($token: String!, $bindingType: BindingType!) {
    setAppPushNotificationToken(token: $token, bindingType: $bindingType)
  }
`
